import { render, staticRenderFns } from "./MenuAlerts.vue?vue&type=template&id=4088e596&scoped=true"
import script from "./MenuAlerts.vue?vue&type=script&lang=js"
export * from "./MenuAlerts.vue?vue&type=script&lang=js"
import style0 from "./MenuAlerts.vue?vue&type=style&index=0&id=4088e596&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4088e596",
  null
  
)

export default component.exports